// return value in object based on provided path in a string
export function getObjectValue(ob, value_path) {
  try {
    return [ob].concat(value_path.split(".")).reduce(function(a, b) {
      return a[b];
    });
  } catch {
    return null;
  }
}

// set object value in object based on provided path in a string
export function setObjectValue(ob, value, value_path) {
  var i;
  var paths = value_path.split(".");
  for (i = 0; i < paths.length - 1; i++) ob = ob[paths[i]];
  ob[paths[i]] = value;
}

// push object value to list
export function pushObjectValue(ob, value, value_path) {
  var i;
  var paths = value_path.split(".");
  for (i = 0; i < paths.length - 1; i++) ob = ob[paths[i]];
  ob[paths[i]].push(value);
}

// deleting object value from list
export function removeObjectValue(ob, value_path, index) {
  var i;
  var paths = value_path.split(".");
  for (i = 0; i < paths.length - 1; i++) ob = ob[paths[i]];
  ob[paths[i]].splice(index, 1);
}
